// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 76 ? "actioncable" : chunkId) + "-" + {"76":"fcee126f7777ca0a0da3","630":"6468a7527f8fdfe43b98"}[chunkId] + ".digested.js";
};